export const VTMN_PRICE_VARIANT = {
  DEFAULT: 'default',
  ACCENT: 'accent',
  ALERT: 'alert',
  STRIKETHROUGH: 'strikethrough',
};

export const VTMN_PRICE_SIZE = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};
